/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "flex justify-center items-center"
};
const _hoisted_2 = {
  class: "dropdown"
};
const _hoisted_3 = {
  class: "m-1 btn btn-square btn-sm btn-ghost"
};
const _hoisted_4 = {
  class: "flex flex-col h-full w-full"
};
const _hoisted_5 = {
  class: "p-2 shadow menu dropdown-content z-[1] bg-base-100 rounded-box"
};
import { useConfigurationStore } from '@/stores/configurationModule';
import { ColorPicker } from "vue-color-kit";
export default {
  __name: 'ShapesObjectEditor',
  setup(__props) {
    const colorPick = ref('white');
    const $eventBus = inject('bus');
    const configurationStore = useConfigurationStore();
    const {
      activeObjects
    } = storeToRefs(configurationStore);
    updatePickerValue();
    onMounted(() => {
      updatePickerValue();
    });
    watch(activeObjects, () => {
      updatePickerValue();
    });
    function handleColorChange(color) {
      const {
        r,
        g,
        b,
        a
      } = color.rgba;
      const rgbaColor = `rgba(${r}, ${g}, ${b}, ${a})`;
      colorPick.value = rgbaColor;
      $eventBus.$emit("object-color-changed", rgbaColor);
    }
    function updatePickerValue() {
      if (activeObjects.value.length === 1) {
        colorPick.value = activeObjects.value[0].fill;
      }
    }
    return (_ctx, _cache) => {
      const _component_SvgIcon = __unplugin_components_0;
      const _directive_tippy = _resolveDirective("tippy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("details", _hoisted_2, [_createElementVNode("summary", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_SvgIcon, {
        class: "h-full w-full p-1 opacity-75",
        fill: "white",
        svgSymbolId: "paint-bucket"
      }), _createElementVNode("div", {
        class: "w-full h-[5px]",
        style: _normalizeStyle({
          'background-color': _unref(colorPick)
        })
      }, null, 4)])), [[_directive_tippy, {
        content: 'Color',
        placement: 'bottom',
        animation: 'scale-subtle',
        delay: 0,
        duration: 0
      }]])]), _createElementVNode("ul", _hoisted_5, [_createVNode(_unref(ColorPicker), {
        style: {
          "width": "220px"
        },
        theme: "dark",
        color: _unref(colorPick),
        onChangeColor: handleColorChange
      }, null, 8, ["color"])])])]);
    };
  }
};